import $ from 'jquery';

$(document).ready(function() {
	if ($(window).width() >= 1024) {
		$('.js-media-masonry').masonry({
			itemSelector: '.js-media-item',
			columnWidth: '.js-media-item'
		});
	}
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-masonry.js